export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE'
export const VERIFY_PERSON = 'VERIFY_PERSON'
export const LOAD_PERSON_CAPABILITIES = 'LOAD_PERSON_CAPABILITIES'

// chat
export const AGENT_LOGIN = 'AGENT_LOGIN'
export const CONNECT_AGENT = 'CONNECT_AGENT'
export const DISCONNECT_AGENT = 'DISCONNECT_AGENT'
export const LOAD_AGENT_CONNECTION = 'LOAD_AGENT_CONNECTION'
export const LOAD_AGENT_CONVERSATIONS = 'LOAD_AGENT_CONVERSATIONS'
export const LOAD_CONVERSATIONS = 'LOAD_CONVERSATIONS'
export const LOAD_MESSAGES = 'LOAD_MESSAGES'
export const LOAD_HISTORY_MESSAGES = 'LOAD_HISTORY_MESSAGES'
export const LOAD_HISTORY_CONVERSATIONS = 'LOAD_HISTORY_CONVERSATIONS'
